import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const setUpdateSortable = async (idOld, idNew, SortsOld,SortsNew,typeDataBase)=>{
    const response = await axios.post(buildApiUrl('reference/setUpdateSortable/'),{
        dataNewSortable: {
            idOld, idNew,
            SortsOld,
            SortsNew,
            typeDataBase
        }
    });

    const { data, TYPE_REDUCER } = response.data;
    const AllStatusOrderUser = {data,TYPE_REDUCER};

    // console.log('Сервер вернул данные по обновлению статуса StatusOrder  - ',response);


    return AllStatusOrderUser;
};


Mock.onPost('/api/reference/setUpdateSortable').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { idOld, idNew, SortsOld, SortsNew, typeDataBase } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllStatusOrderUser = await setUpdateSortable(idOld, idNew, SortsOld,SortsNew,typeDataBase);

    // if (!AllStatusOrderUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllStatusOrderUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStatusOrderUser,
    ]


})